import axios from "axios";
import Cookies from "js-cookie";

export const axiosClient = axios.create({
    headers: {
        "X-XSRF-TOKEN": Cookies.get("XSRF-TOKEN"),
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// Add a response interceptor to handle 500 errors
axiosClient.interceptors.response.use(
    (response) => {
        // console.log({ response });
        // If the response is successful (status code 2xx), just return the response
        return response;
    },
    (error) => {
        console.log({ error });

        // If the response is an error (status code 4xx or 5xx), handle it
        if (error.response && error.response.status === 500) {
            // Handle the 500 error specifically
            console.error("Server error:", error.response);
        }
        // Return a rejected promise to allow further handling in the onError callback
        return Promise.reject(error);
    }
);
